/*** IMPORTS FROM imports-loader ***/
var define = false;

var Flickity = require('flickity');
require('flickity-imagesloaded');

import './parallax.js';
import { parallax } from './parallax.js';

export function tipsSlider() {
  var tipsSliders = document.querySelectorAll('.tipsSection__slider');

  for ( var i=0, len = tipsSliders.length; i < len; i++ ) {
    var tipsSlider = tipsSliders[i];

    if (window.innerWidth < 960) {
      var flkty = new Flickity( tipsSlider, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        pageDots: false,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
            }, 2000);
          }
        }
      });
    } else if (window.innerWidth > 960 && window.innerWidth < 1201) {
      var flkty = new Flickity( tipsSlider, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: 3,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
            }, 2000);
          }
        }
      });
    } else {
      var flkty = new Flickity( tipsSlider, {
        // options
        cellAlign: 'left',
        contain: true,
        imagesLoaded: true,
        wrapAround: false,
        adaptiveHeight: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: 4,
        on: {
          ready: function () {
            setTimeout(() => {
              flkty.resize();
            }, 2000);
          }
        }
      });
    }
  }

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.tipsSection__slider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}
